import dayjs from 'dayjs'
import { EventDoc } from 'types/api/changes'

import { isTestEnv } from './env'
import { isEventRecurrenceInstanceValid } from './api/instance_state'
import { getDefaultTimezone } from 'index'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

export const eventIdFormat = 'YYYY-MM-DD-HH-mm'

export function isEventRecurrenceValid(
  event: EventDoc,
  visibleAreaStart: dayjs.Dayjs
) {
  return isEventRecurrenceInstanceValid(event, visibleAreaStart)
}

export function getPendingEventData() {
  const storedData = LocalStorage.get(LocalStorageKey.PENDING_EVENT_DATA)
  let pendingData: EventDoc | undefined = undefined
  if (storedData) {
    pendingData = JSON.parse(storedData)
  }
  return pendingData
}

export function eventIdForContainer(
  event: EventDoc | undefined,
  instanceStart: number
) {
  if (!event) return instanceStart.toString()
  if (!isTestEnv()) return event._id
  try {
    return event.AllDay === '1'
      ? `${event?.Text}-${dayjs(instanceStart).hour(12).format(eventIdFormat)}`
      : `${event?.Text}-${dayjs(instanceStart)
          .tz(
            (event.TimeZoneNameID?.length ?? 0) > 0
              ? event.TimeZoneNameID
              : getDefaultTimezone()
          )
          .format(eventIdFormat)}`
  } catch (error) {
    return event.AllDay === '1'
      ? `${event?.Text}-${dayjs(instanceStart).hour(12).format(eventIdFormat)}`
      : `${event?.Text}-${dayjs(instanceStart).format(eventIdFormat)}`
  }
}

export function eventLengthInDays(event?: EventDoc) {
  if (!event) return 0
  if (!event.StartDate || !event.EndDate) return 0

  // Convert Unix timestamps to milliseconds
  const startTimestamp = Number(event.StartDate) * 1000
  const endTimestamp = Number(event.EndDate) * 1000

  // Create normalized dates (set to midnight)
  const startDateDay = new Date(startTimestamp)
  startDateDay.setHours(0, 0, 0, 0)

  const endDateDay = new Date(endTimestamp)
  endDateDay.setHours(0, 0, 0, 0)

  // Calculate difference in days
  return (
    Math.round(
      (endDateDay.getTime() - startDateDay.getTime()) / (24 * 60 * 60 * 1000)
    ) + 1
  )
}

export function isEventMoreThanADay(event: EventDoc) {
  return eventLengthInDays(event) > 1
}
